"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const list_item_1 = require("@festival/actuality/list-item");
const reactstrap_1 = require("reactstrap");
class List extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.actualityStore) {
            this.props.actualityStore.loadList();
        }
    }
    render() {
        const { actualityStore } = this.props;
        if (!actualityStore) {
            return null;
        }
        const activities = actualityStore.filteredAndOrderedActualities;
        return (React.createElement(React.Fragment, null, activities.length > 0 && (React.createElement(reactstrap_1.Row, { className: this.rowClass }, activities.map((actuality, index) => (React.createElement(list_item_1.default, { key: index, actuality: actuality })))))));
    }
    get rowClass() {
        return 'row-cols-1 row-cols-md-2 row-cols-lg-3';
    }
}
exports.List = List;
exports.default = mobx_react_1.inject('actualityStore')(mobx_react_1.observer(List));
